export const ratings2 = [
  {
    "year": 2024,
    "team": "Ohio State",
    "conference": "Big Ten",
    "rating": 31.2,
    "ranking": 1,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 3,
      "rating": 39.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 1,
      "rating": 9.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.8
    }
  },
  {
    "year": 2024,
    "team": "Ole Miss",
    "conference": "SEC",
    "rating": 27.9,
    "ranking": 2,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 7,
      "rating": 37.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 3,
      "rating": 11.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 2.1
    }
  },
  {
    "year": 2024,
    "team": "Oregon",
    "conference": "Big Ten",
    "rating": 26,
    "ranking": 3,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 2,
      "rating": 40.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 14,
      "rating": 16.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.5
    }
  },
  {
    "year": 2024,
    "team": "Alabama",
    "conference": "SEC",
    "rating": 25,
    "ranking": 4,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 6,
      "rating": 37.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 8,
      "rating": 14.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.7
    }
  },
  {
    "year": 2024,
    "team": "Penn State",
    "conference": "Big Ten",
    "rating": 24.6,
    "ranking": 5,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 9,
      "rating": 37.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 4,
      "rating": 13.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.2
    }
  },
  {
    "year": 2024,
    "team": "Georgia",
    "conference": "SEC",
    "rating": 24.3,
    "ranking": 6,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 10,
      "rating": 37.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 9,
      "rating": 14.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.9
    }
  },
  {
    "year": 2024,
    "team": "Texas",
    "conference": "SEC",
    "rating": 24.1,
    "ranking": 7,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 13,
      "rating": 36.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 2,
      "rating": 10.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.7
    }
  },
  {
    "year": 2024,
    "team": "Notre Dame",
    "conference": "FBS Independents",
    "rating": 23.9,
    "ranking": 8,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 4,
      "rating": 38.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 7,
      "rating": 14.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.6
    }
  },
  {
    "year": 2024,
    "team": "Tennessee",
    "conference": "SEC",
    "rating": 22,
    "ranking": 9,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 23,
      "rating": 33.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 6,
      "rating": 13.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.7
    }
  },
  {
    "year": 2024,
    "team": "Miami",
    "conference": "ACC",
    "rating": 21.6,
    "ranking": 10,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 1,
      "rating": 44.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 51,
      "rating": 24.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.8
    }
  },
  {
    "year": 2024,
    "team": "Indiana",
    "conference": "Big Ten",
    "rating": 20.1,
    "ranking": 11,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 18,
      "rating": 35,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 15,
      "rating": 16.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.5
    }
  },
  {
    "year": 2024,
    "team": "SMU",
    "conference": "ACC",
    "rating": 17.5,
    "ranking": 12,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 5,
      "rating": 38.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 30,
      "rating": 21.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.4
    }
  },
  {
    "year": 2024,
    "team": "Texas A&M",
    "conference": "SEC",
    "rating": 17,
    "ranking": 13,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 21,
      "rating": 34,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 19,
      "rating": 18.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.6
    }
  },
  {
    "year": 2024,
    "team": "South Carolina",
    "conference": "SEC",
    "rating": 16.9,
    "ranking": 14,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 35,
      "rating": 32.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 13,
      "rating": 16,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.8
    }
  },
  {
    "year": 2024,
    "team": "LSU",
    "conference": "SEC",
    "rating": 15.9,
    "ranking": 15,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 11,
      "rating": 36.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 33,
      "rating": 21.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.8
    }
  },
  {
    "year": 2024,
    "team": "Iowa",
    "conference": "Big Ten",
    "rating": 15.8,
    "ranking": 16,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 69,
      "rating": 27,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 5,
      "rating": 13.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 2
    }
  },
  {
    "year": 2024,
    "team": "BYU",
    "conference": "Big 12",
    "rating": 15.3,
    "ranking": 17,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 36,
      "rating": 32,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 21,
      "rating": 18.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 2
    }
  },
  {
    "year": 2024,
    "team": "Kansas State",
    "conference": "Big 12",
    "rating": 14.1,
    "ranking": 18,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 29,
      "rating": 33,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 25,
      "rating": 20.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.5
    }
  },
  {
    "year": 2024,
    "team": "Missouri",
    "conference": "SEC",
    "rating": 14,
    "ranking": 19,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 23,
      "rating": 33.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 20,
      "rating": 18.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1
    }
  },
  {
    "year": 2024,
    "team": "Florida",
    "conference": "SEC",
    "rating": 13.8,
    "ranking": 20,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 37,
      "rating": 31.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 23,
      "rating": 20,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 2.1
    }
  },
  {
    "year": 2024,
    "team": "Louisville",
    "conference": "ACC",
    "rating": 13.6,
    "ranking": 21,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 7,
      "rating": 37.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 40,
      "rating": 22.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.1
    }
  },
  {
    "year": 2024,
    "team": "Clemson",
    "conference": "ACC",
    "rating": 13.3,
    "ranking": 22,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 16,
      "rating": 35.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 26,
      "rating": 20.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.1
    }
  },
  {
    "year": 2024,
    "team": "USC",
    "conference": "Big Ten",
    "rating": 11.9,
    "ranking": 23,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 15,
      "rating": 35.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 48,
      "rating": 24,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.3
    }
  },
  {
    "year": 2024,
    "team": "Arkansas",
    "conference": "SEC",
    "rating": 11,
    "ranking": 24,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 40,
      "rating": 31.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 33,
      "rating": 21.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.3
    }
  },
  {
    "year": 2024,
    "team": "TCU",
    "conference": "Big 12",
    "rating": 10.8,
    "ranking": 25,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 19,
      "rating": 34.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 38,
      "rating": 22.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.9
    }
  },
  {
    "year": 2024,
    "team": "Michigan",
    "conference": "Big Ten",
    "rating": 10.6,
    "ranking": 26,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 93,
      "rating": 24.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 10,
      "rating": 15.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.7
    }
  },
  {
    "year": 2024,
    "team": "Minnesota",
    "conference": "Big Ten",
    "rating": 10.4,
    "ranking": 27,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 79,
      "rating": 25.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 11,
      "rating": 15.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.2
    }
  },
  {
    "year": 2024,
    "team": "Iowa State",
    "conference": "Big 12",
    "rating": 10.3,
    "ranking": 28,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 44,
      "rating": 30.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 24,
      "rating": 20.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.3
    }
  },
  {
    "year": 2024,
    "team": "Boise State",
    "conference": "Mountain West",
    "rating": 10.1,
    "ranking": 29,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 17,
      "rating": 35.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 50,
      "rating": 24.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1
    }
  },
  {
    "year": 2024,
    "team": "Virginia Tech",
    "conference": "ACC",
    "rating": 10,
    "ranking": 30,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 41,
      "rating": 31.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 36,
      "rating": 22.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.2
    }
  },
  {
    "year": 2024,
    "team": "Illinois",
    "conference": "Big Ten",
    "rating": 9.6,
    "ranking": 31,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 55,
      "rating": 29,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 26,
      "rating": 20.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.5
    }
  },
  {
    "year": 2024,
    "team": "Memphis",
    "conference": "American Athletic",
    "rating": 9.6,
    "ranking": 31,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 12,
      "rating": 36.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 80,
      "rating": 28.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1
    }
  },
  {
    "year": 2024,
    "team": "Auburn",
    "conference": "SEC",
    "rating": 9.5,
    "ranking": 33,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 63,
      "rating": 27.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 17,
      "rating": 17.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.6
    }
  },
  {
    "year": 2024,
    "team": "Oklahoma",
    "conference": "SEC",
    "rating": 9.5,
    "ranking": 33,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 75,
      "rating": 25.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 17,
      "rating": 17.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.4
    }
  },
  {
    "year": 2024,
    "team": "Arizona State",
    "conference": "Big 12",
    "rating": 9.4,
    "ranking": 35,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 32,
      "rating": 32.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 26,
      "rating": 20.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -2.1
    }
  },
  {
    "year": 2024,
    "team": "UNLV",
    "conference": "Mountain West",
    "rating": 9.3,
    "ranking": 36,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 31,
      "rating": 32.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 55,
      "rating": 24.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.3
    }
  },
  {
    "year": 2024,
    "team": "Army",
    "conference": "American Athletic",
    "rating": 9.2,
    "ranking": 37,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 42,
      "rating": 31.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 33,
      "rating": 21.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.1
    }
  },
  {
    "year": 2024,
    "team": "Baylor",
    "conference": "Big 12",
    "rating": 8.4,
    "ranking": 38,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 25,
      "rating": 33.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 63,
      "rating": 26.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.1
    }
  },
  {
    "year": 2024,
    "team": "Colorado",
    "conference": "Big 12",
    "rating": 8.1,
    "ranking": 39,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 27,
      "rating": 33.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 45,
      "rating": 23.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.7
    }
  },
  {
    "year": 2024,
    "team": "Utah",
    "conference": "Big 12",
    "rating": 7.7,
    "ranking": 40,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 96,
      "rating": 23.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 16,
      "rating": 17.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.3
    }
  },
  {
    "year": 2024,
    "team": "James Madison",
    "conference": "Sun Belt",
    "rating": 7.5,
    "ranking": 41,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 49,
      "rating": 29.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 40,
      "rating": 22.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.7
    }
  },
  {
    "year": 2024,
    "team": "Rutgers",
    "conference": "Big Ten",
    "rating": 6.4,
    "ranking": 42,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 58,
      "rating": 28.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 38,
      "rating": 22.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.7
    }
  },
  {
    "year": 2024,
    "team": "Tulane",
    "conference": "American Athletic",
    "rating": 5.7,
    "ranking": 43,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 30,
      "rating": 32.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 73,
      "rating": 27.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.1
    }
  },
  {
    "year": 2024,
    "team": "Duke",
    "conference": "ACC",
    "rating": 5.6,
    "ranking": 44,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 71,
      "rating": 26.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 31,
      "rating": 21.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.2
    }
  },
  {
    "year": 2024,
    "team": "Kentucky",
    "conference": "SEC",
    "rating": 5.5,
    "ranking": 45,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 88,
      "rating": 24.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 26,
      "rating": 20.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 2
    }
  },
  {
    "year": 2024,
    "team": "Syracuse",
    "conference": "ACC",
    "rating": 5.5,
    "ranking": 45,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 14,
      "rating": 35.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 83,
      "rating": 28.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.3
    }
  },
  {
    "year": 2024,
    "team": "Nebraska",
    "conference": "Big Ten",
    "rating": 5.5,
    "ranking": 45,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 99,
      "rating": 23.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 12,
      "rating": 15.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.8
    }
  },
  {
    "year": 2024,
    "team": "Texas State",
    "conference": "Sun Belt",
    "rating": 5.4,
    "ranking": 48,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 20,
      "rating": 34.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 82,
      "rating": 28.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.4
    }
  },
  {
    "year": 2024,
    "team": "North Carolina",
    "conference": "ACC",
    "rating": 5,
    "ranking": 49,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 38,
      "rating": 31.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 64,
      "rating": 26.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.2
    }
  },
  {
    "year": 2024,
    "team": "Vanderbilt",
    "conference": "SEC",
    "rating": 4.9,
    "ranking": 50,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 60,
      "rating": 28.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 59,
      "rating": 25.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 2
    }
  },
  {
    "year": 2024,
    "team": "Pittsburgh",
    "conference": "ACC",
    "rating": 4.9,
    "ranking": 50,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 54,
      "rating": 29.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 64,
      "rating": 26.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.8
    }
  },
  {
    "year": 2024,
    "team": "Kansas",
    "conference": "Big 12",
    "rating": 4.9,
    "ranking": 50,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 32,
      "rating": 32.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 68,
      "rating": 26.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1
    }
  },
  {
    "year": 2024,
    "team": "Louisiana",
    "conference": "Sun Belt",
    "rating": 4.8,
    "ranking": 53,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 38,
      "rating": 31.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 78,
      "rating": 27.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.1
    }
  },
  {
    "year": 2024,
    "team": "Texas Tech",
    "conference": "Big 12",
    "rating": 4.3,
    "ranking": 54,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 25,
      "rating": 33.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 95,
      "rating": 30.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.6
    }
  },
  {
    "year": 2024,
    "team": "California",
    "conference": "ACC",
    "rating": 4,
    "ranking": 55,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 65,
      "rating": 27.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 40,
      "rating": 22.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.5
    }
  },
  {
    "year": 2024,
    "team": "NC State",
    "conference": "ACC",
    "rating": 3.9,
    "ranking": 56,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 47,
      "rating": 29.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 68,
      "rating": 26.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.5
    }
  },
  {
    "year": 2024,
    "team": "Navy",
    "conference": "American Athletic",
    "rating": 3.5,
    "ranking": 57,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 51,
      "rating": 29.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 53,
      "rating": 24.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.7
    }
  },
  {
    "year": 2024,
    "team": "Marshall",
    "conference": "Sun Belt",
    "rating": 3.1,
    "ranking": 58,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 50,
      "rating": 29.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 71,
      "rating": 26.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.4
    }
  },
  {
    "year": 2024,
    "team": "Washington",
    "conference": "Big Ten",
    "rating": 3.1,
    "ranking": 58,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 66,
      "rating": 27.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 36,
      "rating": 22.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.8
    }
  },
  {
    "year": 2024,
    "team": "Wisconsin",
    "conference": "Big Ten",
    "rating": 3,
    "ranking": 60,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 100,
      "rating": 23,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 22,
      "rating": 19.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.2
    }
  },
  {
    "year": 2024,
    "team": "South Alabama",
    "conference": "Sun Belt",
    "rating": 2.8,
    "ranking": 61,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 47,
      "rating": 29.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 71,
      "rating": 26.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.2
    }
  },
  {
    "year": 2024,
    "team": "UCF",
    "conference": "Big 12",
    "rating": 2.8,
    "ranking": 61,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 55,
      "rating": 29,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 61,
      "rating": 25.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.4
    }
  },
  {
    "year": 2024,
    "team": "Ohio",
    "conference": "Mid-American",
    "rating": 2.3,
    "ranking": 63,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 67,
      "rating": 27.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 47,
      "rating": 23.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.9
    }
  },
  {
    "year": 2024,
    "team": "UTSA",
    "conference": "American Athletic",
    "rating": 2.2,
    "ranking": 64,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 34,
      "rating": 32.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 101,
      "rating": 31.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.4
    }
  },
  {
    "year": 2024,
    "team": "West Virginia",
    "conference": "Big 12",
    "rating": 2.1,
    "ranking": 65,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 46,
      "rating": 30.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 87,
      "rating": 29.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.8
    }
  },
  {
    "year": 2024,
    "team": "Georgia Tech",
    "conference": "ACC",
    "rating": 1.9,
    "ranking": 66,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 42,
      "rating": 31.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 79,
      "rating": 27.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.3
    }
  },
  {
    "year": 2024,
    "team": "UConn",
    "conference": "FBS Independents",
    "rating": 1.5,
    "ranking": 67,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 70,
      "rating": 26.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 60,
      "rating": 25.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.3
    }
  },
  {
    "year": 2024,
    "team": "Miami (OH)",
    "conference": "Mid-American",
    "rating": 1.3,
    "ranking": 68,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 98,
      "rating": 23.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 43,
      "rating": 23.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.3
    }
  },
  {
    "year": 2024,
    "team": "Washington State",
    "conference": "Pac-12",
    "rating": 1.3,
    "ranking": 68,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 21,
      "rating": 34,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 97,
      "rating": 31.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.5
    }
  },
  {
    "year": 2024,
    "team": "Boston College",
    "conference": "ACC",
    "rating": 1.2,
    "ranking": 70,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 62,
      "rating": 28,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 56,
      "rating": 24.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -2.1
    }
  },
  {
    "year": 2024,
    "team": "Liberty",
    "conference": "Conference USA",
    "rating": 0.2,
    "ranking": 71,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 60,
      "rating": 28.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 70,
      "rating": 26.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.5
    }
  },
  {
    "year": 2024,
    "team": "Cincinnati",
    "conference": "Big 12",
    "rating": -0.1,
    "ranking": 72,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 79,
      "rating": 25.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 57,
      "rating": 25,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.7
    }
  },
  {
    "year": 2024,
    "team": "East Carolina",
    "conference": "American Athletic",
    "rating": -1,
    "ranking": 73,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 58,
      "rating": 28.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 87,
      "rating": 29.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.2
    }
  },
  {
    "year": 2024,
    "team": "Jacksonville State",
    "conference": "Conference USA",
    "rating": -1,
    "ranking": 73,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 57,
      "rating": 28.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 81,
      "rating": 28.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.5
    }
  },
  {
    "year": 2024,
    "team": "UCLA",
    "conference": "Big Ten",
    "rating": -1.3,
    "ranking": 75,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 103,
      "rating": 21.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 44,
      "rating": 23.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.7
    }
  },
  {
    "year": 2024,
    "team": "Georgia Southern",
    "conference": "Sun Belt",
    "rating": -1.7,
    "ranking": 76,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 72,
      "rating": 26.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 90,
      "rating": 30.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.9
    }
  },
  {
    "year": 2024,
    "team": "Bowling Green",
    "conference": "Mid-American",
    "rating": -1.8,
    "ranking": 77,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 79,
      "rating": 25.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 75,
      "rating": 27.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.2
    }
  },
  {
    "year": 2024,
    "team": "Western Kentucky",
    "conference": "Conference USA",
    "rating": -2.2,
    "ranking": 78,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 101,
      "rating": 22.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 62,
      "rating": 26.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.8
    }
  },
  {
    "year": 2024,
    "team": "South Florida",
    "conference": "American Athletic",
    "rating": -2.3,
    "ranking": 79,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 51,
      "rating": 29.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 108,
      "rating": 33.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.6
    }
  },
  {
    "year": 2024,
    "team": "Toledo",
    "conference": "Mid-American",
    "rating": -2.5,
    "ranking": 80,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 88,
      "rating": 24.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 64,
      "rating": 26.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.7
    }
  },
  {
    "year": 2024,
    "team": "Oklahoma State",
    "conference": "Big 12",
    "rating": -2.6,
    "ranking": 81,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 53,
      "rating": 29.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 102,
      "rating": 31.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.4
    }
  },
  {
    "year": 2024,
    "team": "Arizona",
    "conference": "Big 12",
    "rating": -2.8,
    "ranking": 82,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 90,
      "rating": 24.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 84,
      "rating": 29,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.8
    }
  },
  {
    "year": 2024,
    "team": "Florida State",
    "conference": "ACC",
    "rating": -3.2,
    "ranking": 83,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 114,
      "rating": 20.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 58,
      "rating": 25.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 2
    }
  },
  {
    "year": 2024,
    "team": "Northern Illinois",
    "conference": "Mid-American",
    "rating": -3.5,
    "ranking": 84,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 115,
      "rating": 20,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 32,
      "rating": 21.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.9
    }
  },
  {
    "year": 2024,
    "team": "Fresno State",
    "conference": "Mountain West",
    "rating": -3.8,
    "ranking": 85,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 85,
      "rating": 25.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 77,
      "rating": 27.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.4
    }
  },
  {
    "year": 2024,
    "team": "Maryland",
    "conference": "Big Ten",
    "rating": -3.9,
    "ranking": 86,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 97,
      "rating": 23.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 73,
      "rating": 27.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.1
    }
  },
  {
    "year": 2024,
    "team": "Buffalo",
    "conference": "Mid-American",
    "rating": -4,
    "ranking": 87,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 84,
      "rating": 25.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 93,
      "rating": 30.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.8
    }
  },
  {
    "year": 2024,
    "team": "Mississippi State",
    "conference": "SEC",
    "rating": -4.1,
    "ranking": 88,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 82,
      "rating": 25.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 98,
      "rating": 31.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.5
    }
  },
  {
    "year": 2024,
    "team": "North Texas",
    "conference": "American Athletic",
    "rating": -4.5,
    "ranking": 89,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 27,
      "rating": 33.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 121,
      "rating": 37,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.8
    }
  },
  {
    "year": 2024,
    "team": "Michigan State",
    "conference": "Big Ten",
    "rating": -4.6,
    "ranking": 90,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 119,
      "rating": 18,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 49,
      "rating": 24.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.4
    }
  },
  {
    "year": 2024,
    "team": "Virginia",
    "conference": "ACC",
    "rating": -5.1,
    "ranking": 91,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 95,
      "rating": 23.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 86,
      "rating": 29.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.5
    }
  },
  {
    "year": 2024,
    "team": "San Jos\u00e9 State",
    "conference": "Mountain West",
    "rating": -5.5,
    "ranking": 92,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 73,
      "rating": 26.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 90,
      "rating": 30.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.5
    }
  },
  {
    "year": 2024,
    "team": "Wake Forest",
    "conference": "ACC",
    "rating": -5.7,
    "ranking": 93,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 77,
      "rating": 25.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 103,
      "rating": 31.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.3
    }
  },
  {
    "year": 2024,
    "team": "Colorado State",
    "conference": "Mountain West",
    "rating": -5.7,
    "ranking": 93,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 92,
      "rating": 24.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 85,
      "rating": 29.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.8
    }
  },
  {
    "year": 2024,
    "team": "Old Dominion",
    "conference": "Sun Belt",
    "rating": -6,
    "ranking": 95,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 78,
      "rating": 25.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 99,
      "rating": 31.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.4
    }
  },
  {
    "year": 2024,
    "team": "Troy",
    "conference": "Sun Belt",
    "rating": -6.6,
    "ranking": 96,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 93,
      "rating": 24.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 90,
      "rating": 30.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.6
    }
  },
  {
    "year": 2024,
    "team": "Oregon State",
    "conference": "Pac-12",
    "rating": -6.7,
    "ranking": 97,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 73,
      "rating": 26.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 107,
      "rating": 32.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0
    }
  },
  {
    "year": 2024,
    "team": "Coastal Carolina",
    "conference": "Sun Belt",
    "rating": -6.9,
    "ranking": 98,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 82,
      "rating": 25.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 108,
      "rating": 33.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1
    }
  },
  {
    "year": 2024,
    "team": "Sam Houston",
    "conference": "Conference USA",
    "rating": -6.9,
    "ranking": 98,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 117,
      "rating": 19,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 46,
      "rating": 23.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -2.1
    }
  },
  {
    "year": 2024,
    "team": "App State",
    "conference": "Sun Belt",
    "rating": -8.1,
    "ranking": 100,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 67,
      "rating": 27.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 110,
      "rating": 33.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.6
    }
  },
  {
    "year": 2024,
    "team": "Houston",
    "conference": "Big 12",
    "rating": -8.2,
    "ranking": 101,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 118,
      "rating": 18.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 54,
      "rating": 24.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.8
    }
  },
  {
    "year": 2024,
    "team": "Stanford",
    "conference": "ACC",
    "rating": -8.2,
    "ranking": 101,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 90,
      "rating": 24.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 112,
      "rating": 34.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.5
    }
  },
  {
    "year": 2024,
    "team": "Northwestern",
    "conference": "Big Ten",
    "rating": -8.2,
    "ranking": 101,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 124,
      "rating": 17.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 51,
      "rating": 24.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.4
    }
  },
  {
    "year": 2024,
    "team": "Arkansas State",
    "conference": "Sun Belt",
    "rating": -9.9,
    "ranking": 104,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 87,
      "rating": 24.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 119,
      "rating": 35.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.7
    }
  },
  {
    "year": 2024,
    "team": "Western Michigan",
    "conference": "Mid-American",
    "rating": -10.2,
    "ranking": 105,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 86,
      "rating": 24.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 120,
      "rating": 36,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.1
    }
  },
  {
    "year": 2024,
    "team": "Utah State",
    "conference": "Mountain West",
    "rating": -10.4,
    "ranking": 106,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 45,
      "rating": 30.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 129,
      "rating": 40.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.3
    }
  },
  {
    "year": 2024,
    "team": "Hawai'i",
    "conference": "Mountain West",
    "rating": -10.9,
    "ranking": 107,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 108,
      "rating": 20.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 89,
      "rating": 30,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.8
    }
  },
  {
    "year": 2024,
    "team": "UAB",
    "conference": "American Athletic",
    "rating": -11.3,
    "ranking": 108,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 75,
      "rating": 25.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 126,
      "rating": 38,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.9
    }
  },
  {
    "year": 2024,
    "team": "Rice",
    "conference": "American Athletic",
    "rating": -11.4,
    "ranking": 109,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 110,
      "rating": 20.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 94,
      "rating": 30.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.4
    }
  },
  {
    "year": 2024,
    "team": "Louisiana Tech",
    "conference": "Conference USA",
    "rating": -11.6,
    "ranking": 110,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 128,
      "rating": 15.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 64,
      "rating": 26.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.2
    }
  },
  {
    "year": 2024,
    "team": "Air Force",
    "conference": "Mountain West",
    "rating": -11.7,
    "ranking": 111,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 120,
      "rating": 17.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 76,
      "rating": 27.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -2
    }
  },
  {
    "year": 2024,
    "team": "Florida International",
    "conference": "Conference USA",
    "rating": -12.1,
    "ranking": 112,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 110,
      "rating": 20.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 99,
      "rating": 31.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.2
    }
  },
  {
    "year": 2024,
    "team": "Florida Atlantic",
    "conference": "American Athletic",
    "rating": -12.7,
    "ranking": 113,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 109,
      "rating": 20.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 104,
      "rating": 32.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.5
    }
  },
  {
    "year": 2024,
    "team": "Eastern Michigan",
    "conference": "Mid-American",
    "rating": -13.3,
    "ranking": 114,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 110,
      "rating": 20.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 115,
      "rating": 34.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.5
    }
  },
  {
    "year": 2024,
    "team": "Wyoming",
    "conference": "Mountain West",
    "rating": -13.6,
    "ranking": 115,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 127,
      "rating": 16.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 95,
      "rating": 30.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.9
    }
  },
  {
    "year": 2024,
    "team": "New Mexico",
    "conference": "Mountain West",
    "rating": -14.8,
    "ranking": 116,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 64,
      "rating": 27.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 132,
      "rating": 40.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.9
    }
  },
  {
    "year": 2024,
    "team": "Nevada",
    "conference": "Mountain West",
    "rating": -15.2,
    "ranking": 117,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 106,
      "rating": 21,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 113,
      "rating": 34.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -2
    }
  },
  {
    "year": 2024,
    "team": "Charlotte",
    "conference": "American Athletic",
    "rating": -15.3,
    "ranking": 118,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 102,
      "rating": 21.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 124,
      "rating": 37.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.9
    }
  },
  {
    "year": 2024,
    "team": "San Diego State",
    "conference": "Mountain West",
    "rating": -15.4,
    "ranking": 119,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 122,
      "rating": 17.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 104,
      "rating": 32.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.9
    }
  },
  {
    "year": 2024,
    "team": "Central Michigan",
    "conference": "Mid-American",
    "rating": -15.8,
    "ranking": 120,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 122,
      "rating": 17.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 115,
      "rating": 34.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.9
    }
  },
  {
    "year": 2024,
    "team": "Purdue",
    "conference": "Big Ten",
    "rating": -16.2,
    "ranking": 121,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 116,
      "rating": 19.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 110,
      "rating": 33.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.8
    }
  },
  {
    "year": 2024,
    "team": "UL Monroe",
    "conference": "Sun Belt",
    "rating": -16.7,
    "ranking": 122,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 126,
      "rating": 16.9,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 106,
      "rating": 32.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1
    }
  },
  {
    "year": 2024,
    "team": "Georgia State",
    "conference": "Sun Belt",
    "rating": -17.9,
    "ranking": 123,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 106,
      "rating": 21,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 123,
      "rating": 37.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.5
    }
  },
  {
    "year": 2024,
    "team": "Akron",
    "conference": "Mid-American",
    "rating": -17.9,
    "ranking": 123,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 129,
      "rating": 15.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 117,
      "rating": 34.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1
    }
  },
  {
    "year": 2024,
    "team": "New Mexico State",
    "conference": "Conference USA",
    "rating": -19,
    "ranking": 125,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 120,
      "rating": 17.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 127,
      "rating": 38.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 1.3
    }
  },
  {
    "year": 2024,
    "team": "Ball State",
    "conference": "Mid-American",
    "rating": -19.8,
    "ranking": 126,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 103,
      "rating": 21.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 133,
      "rating": 40.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.3
    }
  },
  {
    "year": 2024,
    "team": "Temple",
    "conference": "American Athletic",
    "rating": -20.3,
    "ranking": 127,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 125,
      "rating": 17.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 125,
      "rating": 37.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.3
    }
  },
  {
    "year": 2024,
    "team": "Tulsa",
    "conference": "American Athletic",
    "rating": -20.6,
    "ranking": 128,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 105,
      "rating": 21.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 129,
      "rating": 40.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.6
    }
  },
  {
    "year": 2024,
    "team": "Massachusetts",
    "conference": "Mid-American",
    "rating": -21.9,
    "ranking": 129,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 110,
      "rating": 20.5,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 129,
      "rating": 40.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -2.1
    }
  },
  {
    "year": 2024,
    "team": "UTEP",
    "conference": "Conference USA",
    "rating": -22.7,
    "ranking": 130,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 131,
      "rating": 13.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 113,
      "rating": 34.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -2.1
    }
  },
  {
    "year": 2024,
    "team": "Middle Tennessee",
    "conference": "Conference USA",
    "rating": -24.4,
    "ranking": 131,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 131,
      "rating": 13.7,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 122,
      "rating": 37.3,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.8
    }
  },
  {
    "year": 2024,
    "team": "Kennesaw State",
    "conference": "Conference USA",
    "rating": -25.1,
    "ranking": 132,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 134,
      "rating": 10.2,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 118,
      "rating": 35.1,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.3
    }
  },
  {
    "year": 2024,
    "team": "Southern Miss",
    "conference": "Sun Belt",
    "rating": -25.6,
    "ranking": 133,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 130,
      "rating": 14.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 128,
      "rating": 39.4,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -0.6
    }
  },
  {
    "year": 2024,
    "team": "Kent State",
    "conference": "Mid-American",
    "rating": -33,
    "ranking": 134,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": 133,
      "rating": 12.6,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": 134,
      "rating": 43.8,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": -1.9
    }
  },
  {
    "year": 2024,
    "team": "nationalAverages",
    "rating": 0.5522388059701493,
    "ranking": null,
    "secondOrderWins": null,
    "sos": null,
    "offense": {
      "ranking": null,
      "rating": 27.144029850746268,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "runRate": null,
      "pace": null
    },
    "defense": {
      "ranking": null,
      "rating": 26.60970149253731,
      "success": null,
      "explosiveness": null,
      "rushing": null,
      "passing": null,
      "standardDowns": null,
      "passingDowns": null,
      "havoc": {
        "total": null,
        "frontSeven": null,
        "db": null
      }
    },
    "specialTeams": {
      "rating": 0.020895522388059702
    }
  }
]